import verifactu from '@/api/apiSferest/services/verifactu'
import {apificateDate} from '@/helpers/formatDate'

export const getList = ({ commit, dispatch, state }) => {
  dispatch('errors/empty', {}, { root: true })
  return new Promise((resolve, reject) => {
    commit('SET_LOADED', false)
    let params = {}
    if (state.params) {
      let fechaDesde = apificateDate(state.params.fechaDesde)
      let fechaHasta = apificateDate(state.params.fechaHasta)
      if (fechaDesde) params.fechaDesde = fechaDesde
      if (fechaHasta) params.fechaHasta = fechaHasta
    }
    verifactu.getPendientes(params)
    .then((res) => {
      commit('list/SET_LIST', res.data)
      commit('SET_LOADED', true)
      resolve(res.data)
    }, (err) => {
      commit('SET_LOADED', true)
      reject(err)
    })
  })
}

export const resetParams = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_PARAMS', {})
    resolve()
  })
}

export const loadEnviadas = ({ commit, dispatch }) => {
  dispatch('errors/empty', {}, { root: true })
  return new Promise((resolve, reject) => {
    commit('SET_LOADED', false)
    verifactu.getEnviadas()
    .then((res) => {
      commit('SET_ENVIADAS', res.data)
      commit('SET_LOADED', true)
      resolve(res.data)
    }, (err) => {
      commit('SET_LOADED', true)
      reject(err)
    })
  })
}

export const loadRegistrosComprobables = ({ commit, dispatch }) => {
  dispatch('errors/empty', {}, { root: true })
  return new Promise((resolve, reject) => {
    commit('SET_LOADED', false)
    verifactu.getRegistrosComprobables()
    .then((res) => {
      commit('SET_REGISTROS', res.data)
      commit('SET_LOADED', true)
      resolve(res.data)
    }, (err) => {
      commit('SET_LOADED', true)
      reject(err)
    })
  })
}

export const comprobarFactura = ({ commit }, idFactura) => {
  return verifactu.comprobarHuellaFactura(idFactura)
  .then((res) => {
    commit('SET_COMPROBACION', res.data)
    return res.data
  })
}

export const comprobarEvento = ({ commit }, id) => {
  return verifactu.comprobarHuellaEvento(id)
  .then((res) => {
    commit('SET_COMPROBACION', res.data)
    return res.data
  })
}

export const enviarRequerimiento = ({ commit, getters, state }) => {
  let selectedItems = getters['list/getSelectedItems']
  let idsFactura = selectedItems.map(x => x.idFactura)
  return verifactu.enviarRequerimiento({
    idsFactura,
    numeroRequerimiento: state.numeroRequerimiento
  })
  .then((res) => {
    commit('SET_RESULT', res.data)
    return res.data
  })
}

export const exportarRegistros = ({ commit }, params = {}) => {
  let query = {}
  const fechaDesde = apificateDate(params.fechaDesde)
  const fechaHasta = apificateDate(params.fechaHasta)
  if (fechaDesde) query.fechaDesde = fechaDesde
  if (fechaHasta) query.fechaHasta = fechaHasta
  return verifactu.exportarRegistros(query)
  .then((res) => {
    commit('SET_RESULTADO_EXPORTACION', res.data)
    return res.data
  })
}

export const reset = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_NUMERO_REQUERIMIENTO', '')
    commit('SET_RESULT', undefined)
    commit('SET_ENVIADAS', [])
    commit('SET_REGISTROS', [])
    commit('SET_COMPROBACION', undefined)
    commit('SET_RESULTADO_EXPORTACION', undefined)
    commit('SET_PARAMS', {})
    commit('SET_LOADED', false)
    resolve()
  })
}
